export const ELECTIONS = [
  {
    'key': 'parliament',
    'name': 'नेपाल',
    'province': 0,
    'seats': {
      total: 275,
      direct: 165,
      proportional: 110,
      majority: 138
    }
  },
  {
    'key': 'pradesh7',
    'name': 'प्रदेश नं ७',
    'province': 7,
    'seats': {
      total: 53,
      direct: 32,
      proportional: 27,
      majority: 47
    }
  },
  {
    'key': 'pradesh6',
    'name': 'प्रदेश नं ६',
    'province': 4,
    'seats': {
      total: 40,
      direct: 24,
      proportional: 16,
      majority: 21
    }
  },
  {
    'key': 'pradesh5',
    'name': 'प्रदेश नं ५',
    'province': 6,
    'seats': {
      total: 87,
      direct: 52,
      proportional: 35,
      majority: 44
    }
  },
  {
    'key': 'pradesh4',
    'name': 'प्रदेश नं ४',
    'province': 3,
    'seats': {
      total: 60,
      direct: 36,
      proportional: 24,
      majority: 31
    }
  },
  {
    'key': 'pradesh3',
    'name': 'प्रदेश नं ३',
    'province': 2,
    'seats': {
      total: 110,
      direct: 66,
      proportional: 44,
      majority: 56
    }
  },
  {
    'key': 'pradesh2',
    'name': 'प्रदेश नं २',
    'province': 5,
    'seats': {
      total: 107,
      direct: 64,
      proportional: 43,
      majority: 54
    }
  },
  {
    'key': 'pradesh1',
    'name': 'प्रदेश नं १',
    'province': 8,
    'seats': {
      total: 93,
      direct: 56,
      proportional: 37,
      majority: 47
    }
  }
]


// WEBPACK FOOTER //
// ./src/elections.js